import { Component, OnInit, ViewChild } from '@angular/core';
// import { ngxCsv } from 'ngx-csv/ngx-csv'; 
import { Angular2CsvComponent } from "angular2-csv";
import { DatepickerOptions } from 'ng2-datepicker';
import * as moment from 'moment';


/**
 * Service file import
 */
import { SearchEventService } from "../../../services/search/searchEvent/search-event.service";
import { SearchEventCountService } from "../../../services/search/searchEventCount/search-event-count.service";
import { PrintLabelService } from "../../../services/search/printLabel/print-label.service";
import { SearchContactCategoryService } from "../../../services/search/searchContactCategory/search-contact-category.service";
import { GetBankService } from "../../../services/receipts/getBank/get-bank.service"
import { GetOfferingTypeService } from "../../../services/receipts/getOfferingType/get-offering-type.service"
import { ReceiptSearchService } from "../../../services/search/receiptSearch/receipt-search.service";
import { ModeService } from "../../../services/search/getMode/mode.service";
import { OfferingTypeEventBasedService } from "../../../services/search/offeringTypeEventBased/offering-type-event-based.service";

declare var $: any;
@Component({
  selector: 'app-search-detaies',
  templateUrl: './search-detaies.component.html',
  styleUrls: ['./search-detaies.component.less']
})
export class SearchDetaiesComponent implements OnInit {

  @ViewChild(Angular2CsvComponent, null) csvComponent: Angular2CsvComponent;
  options: any = {}
  data: any = []

  childValue

  public search: any = {
    eventSearch: false,
    magazineSearch: false,
    contactSearch: false,
    partnerCodeSearch: false,
    receiptSearch: false
  }

  public magazineSearch: any = {
    tamil: false,
    english: false,
    hindi: false
  }

  public isDisable = true
  public contactComp = false
  public skeletonLoader = true
  public selectEventSkeleton = true
  public selectReceiptEventSkeleton = true
  public contactEventSkeleton = true
  public bankSkeleton = true
  public offeringTypeSkeleton = true
  public modeSkeleton = true
  public eventList: any
  public CategoryList: any
  public submitLoading: Boolean = false
  public exportButtonLoading: Boolean = false
  public fileName: any

  public printPage = false

  public Bank: any = []
  public offeringTypeData: any
  public offeringTypeEventBasedData: any
  public mode: any

  public totalCount: any
  public ID: any

  public eventBasedOfferingType: Boolean = false
  public offeringTypeEventBasedSkeleton: Boolean = true

  public contactORReceipts: any
  public noRecordFound: Boolean = false



  /**
   * For Date picker options
   */
  datePickerOptions: DatepickerOptions = {
    minYear: 1970,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday 
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  constructor(
    private SearchEventService: SearchEventService,
    private SearchEventCountService: SearchEventCountService,
    private GetBankService: GetBankService,
    private GetOfferingTypeService: GetOfferingTypeService,
    private PrintLabelService: PrintLabelService,
    private SearchContactCategoryService: SearchContactCategoryService,
    private ReceiptSearchService: ReceiptSearchService,
    private ModeService: ModeService,
    private OfferingTypeEventBasedService:OfferingTypeEventBasedService
  ) { }

  ngOnInit() {

  }

  async eventSelectionBoxRefresh() {
    await this.getEventLists()
    let root = this
    setTimeout(function () {
      root.selectEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.event`).selectpicker('refresh');
    }, 100)
  }

  async eventReceiptSelectionBoxRefresh() {
    await this.getEventLists()
    let root = this
    setTimeout(function () {
      root.selectReceiptEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.event`).selectpicker('refresh');
    }, 100)
  }

  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

  async bankSelectionBoxRefresh() {
    await this.getBank()
    let root = this
    setTimeout(function () {
      root.bankSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.bank`).selectpicker('refresh');
    }, 100)
  }

  async offeringTypeSelectionBoxRefresh() {
    await this.getOfferingType()
    let root = this
    setTimeout(function () {
      root.offeringTypeSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringType`).selectpicker('refresh');
    }, 100)
  }

  async offeringTypeEventBasedSelectionBoxRefresh() {
    await this.getOfferingTypeEventBased()
    let root = this
    setTimeout(function () {
      root.offeringTypeEventBasedSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.offeringTypeEventBased`).selectpicker('refresh');
    }, 100)
  }

  async modeSelectionBoxRefresh() {
    await this.getMode()
    let root = this
    setTimeout(function () {
      root.modeSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.mode`).selectpicker('refresh');
    }, 100)
  }

  async getBank() {
    let data = await this.GetBankService.GetBank()
    this.Bank = data.data
  }

  async getOfferingType() {
    let data = await this.GetOfferingTypeService.GetOfferingType()
    this.offeringTypeData = data.data
  }

  async getOfferingTypeEventBased() {
    let data = await this.OfferingTypeEventBasedService.getOfferingTypeEvent()
    this.offeringTypeEventBasedData = data.data
  }

  async getMode() {
    let data = await this.ModeService.getMode()
    this.mode = data.data
  }


  async contactSelectionBoxRefresh() {
    await this.getContactCategoryLists()
    let root = this
    setTimeout(function () {
      root.contactEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.contact`).selectpicker('refresh');
    }, 100)
  }

  async getContactCategoryLists() {
    let category = await this.SearchContactCategoryService.getContactCategoryList()
    this.CategoryList = category.data
  }


  public withMobileNo = 0
  public printLabelLoader = false
  public printLabelWithMobileNoLoader = false
  async printLabel(mobileNo) {
    // await this.EventPrintLabelFunction.getEventPrintLabel(this.eventID) 
    
    if(mobileNo == true){
      this.printLabelWithMobileNoLoader = true
      this.withMobileNo = 1
    }else{
      this.printLabelLoader = true
      this.withMobileNo = 2
    }
    setTimeout(() => {
      this.printLabelLoader = false
      this.printLabelWithMobileNoLoader = false
      window.print()
    }, 5000);
   
  }

  async searchWithDetails(ele) {
    this.submitLoading = true
    this.contactComp = true
    this.skeletonLoader = true
    if (this.search.eventSearch) {
      this.printPage = true
      this.contactORReceipts = "Contacts"
      this.ID = { "event_id": ele.event, "role_id": 0, "language_id": 0 }
      let query = { "event_id": ele.event, "role_id": 0, "language_id": 0 }
      await this.exportToCSVOptions(query)
      this.totalCount = await this.getSearchEventCount(query)
    } else if (this.search.contactSearch) {
      this.contactORReceipts = "Contacts"
      this.printPage = true
      this.ID = { "event_id": 0, "role_id": ele.contact, "language_id": 0 }
      let query = { "event_id": 0, "role_id": ele.contact }
      await this.exportToCSVOptions(query)
      this.totalCount = await this.getSearchEventCount(query)
    } else if (this.search.magazineSearch) {
      this.contactORReceipts = "Contacts"
      this.printPage = true
      if (this.magazineSearch.tamil) {
        this.ID = { "event_id": 0, "role_id": 0, "language_id": 19 }
        let query = { "event_id": 0, "role_id": 0, "language_id": 19 }
        await this.exportToCSVOptions(query)
        this.totalCount = await this.getSearchEventCount(query)
      } else if (this.magazineSearch.english) {
        this.ID = { "event_id": 0, "role_id": 0, "language_id": 1 }
        let query = { "event_id": 0, "role_id": 0, "language_id": 1 }
        await this.exportToCSVOptions(query)
        this.totalCount = await this.getSearchEventCount(query)
      } else if (this.magazineSearch.hindi) {
        this.ID = { "event_id": 0, "role_id": 0, "language_id": 7 }
        let query = { "event_id": 0, "role_id": 0, "language_id": 7 }
        await this.exportToCSVOptions(query)
        this.totalCount = await this.getSearchEventCount(query)
      }
    } else if (this.search.partnerCodeSearch) {
      this.contactORReceipts = "Contacts"
      this.printPage = true
      let split = ele.partnerCodeSearch.split("\n")
      this.totalCount = split.length
      this.ID = { "reqParams": "post", "value": ele.partnerCodeSearch, }
      await this.exportToCSVOptions(this.ID)
    } else if (this.search.receiptSearch) {
      this.contactORReceipts = "Receipts"
      let data = {
        fromDate: ele.fromDate == null ? null : moment(ele.fromDate).format("YYYY-MM-DD"),
        toDate: ele.toDate == null ? null : moment(ele.toDate).format("YYYY-MM-DD"),
        offerType: ele.offeringType == "" ? 0 : ele.offeringType.toString(),
        bank: ele.bank == "" ? 0 : ele.bank.toString(),
        mode: ele.mode == "" ? 0 : ele.mode.toString(),
        amtGreater: ele.amtGreater == "" ? 0 : parseInt(ele.amtGreater),
        amtLesser: ele.amtLesser == "" ? 0 : parseInt(ele.amtLesser),
        receiptEvent: ele.receiptEvent == "" ? 0 : parseInt(ele.receiptEvent),
        offeringTypeEventBased: ele.offeringTypeEventBased == "" ? 0 : parseInt(ele.offeringTypeEventBased),
      }
      this.receiptSearchCSVExport(data)
    }



  }

  async getSearchEventCount(query) {
    let count = await this.SearchEventCountService.getEventCount(query)
    this.submitLoading = false
    this.skeletonLoader = false
    return count.data

  }

  async receiptSearchCSVExport(query) {
    let today = new Date();
    this.fileName = "Receipt_search" + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();;
    // this.options = {
    //   fieldSeparator: ',',
    //   quoteStrings: '"',
    //   decimalseparator: '.',
    //   showLabels: false,
    //   headers: ["Partner Id", "Full Name", "Title", "Primary Mobile No", "Address Line 1", "Address Line 2", "Address Line 3", "City", "Pincode", "District", "Province", "State", "Country", "Receipt Disp Num", "Total Amount", "Receipt Id", "Remarks", "Created Time", "Staff Name", "Ambasstor Name", "Receipt Date", "Items", "Cash Medium", "Bank Medium", "Gateway Name", "Bank Name", "Drawee Bank", "Chq DD Number", "Depos Transf DD Chq Issue Date", "NEFT RTGS Ref Number", "Received Medium Id", "Mo Trans Date", "Payment Gate Trans Date"],
    //   showTitle: false,
    //   title: 'BPM Contacts',
    //   useBom: false,
    //   removeNewLines: true,
    //   keys: ["partner_id", "full_name", "title", "primary_mobile_no", "address_line1", "address_line2", "address_line3", "city", "pincode", "district", "province", "state_name", "country_name", "receipt_disp_num", "total_amount", "receipt_id", "remarks", "created_time", "staffname", "ambasstor_name", "receipt_date", "items", "cashmedium", "bankmedium", "gatewayname", "bankname", "draweebank", "chq_dd_num", "depos_transf_dd__chq_issue_date", "neft_rtgs_ref_num", "received_medium_id", "mo_trans_date", "payment_gate_trans_date"]
    // };
    let JSONDATA = await this.ReceiptSearchService.receiptSearch(query)
    this.totalCount = JSONDATA.data.length
    if(this.totalCount == 0){
      this.noRecordFound = true
    }else{
      this.noRecordFound = false
    } 
    let keyValue = await this.separateKeyValue(JSONDATA.keys)
    this.data = JSONDATA.data
    this.options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: keyValue,
      showTitle: false,
      title: 'BPM Contacts',
      useBom: false,
      removeNewLines: true,
      keys:  JSONDATA.keys
     };
    this.skeletonLoader = false
    this.submitLoading = false
  }

  async separateKeyValue(val){
    let data =[]

    for (const key in val) {
      if (val.hasOwnProperty(key)) {
        const element = val[key];
        let temp = element.split("_")
           data.push(await this.splitAndCap(temp))
      }
    } 
    return data
  }

  async splitAndCap(e){
    let fs = ""
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      fs += await this.capitalize(element) +" "
    }
    return fs
  }

  async capitalize (s) { 
    return s.charAt(0).toUpperCase() + s.slice(1)
  }


  async exportToCSVOptions(query) {
    this.noRecordFound = false
    let today = new Date();
    this.fileName = "BPM_Search_Contact_" + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '_' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();;
    this.options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: ["Partner Id", "Full Name", "Title", "Primary Mobile No", "Address Line 1", "Address Line 2", "Address Line 3", "City", "Pincode", "District", "Province", "State", "Country"],
      showTitle: false,
      title: 'BPM Contacts',
      useBom: false,
      removeNewLines: true,
      keys: ["partner_id", "full_name", "title", "primary_mobile_no", "address_line1", "address_line2", "address_line3", "city", "pincode", "district", "province", "state_name", "country_name"]
    };

    if (query.reqParams == "post") {
      let split = query.value.split("\n")
      let data = {
        "partners_list": split
      }
      let JSONDATA = await this.PrintLabelService.postEventPrintLabel(data)
      this.data = JSONDATA.data
    } else {
      let JSONDATA = await this.PrintLabelService.getEventPrintLabel(query)
      this.data = JSONDATA.data
    }


  }

  async exportToCSV() {
    this.exportButtonLoading = true
    setTimeout(() => {
      this.csvComponent.onDownload();
      this.exportButtonLoading = false
    }, 1000)
  }

  async reInitContentComp() {
    this.contactComp = false
  }

  async getEventId(value){
    this.contactComp = false
    if(value != ""){
        this.eventBasedOfferingType = true
        this.offeringTypeEventBasedSkeleton = true
        this.offeringTypeEventBasedSelectionBoxRefresh()
    }else{
      this.eventBasedOfferingType = false
    }
  }

  async cancelSearch() {
    this.search.eventSearch = false
    this.submitLoading = false
    this.search.contactSearch = false
    this.search.magazineSearch = false
    this.search.partnerCodeSearch = false
    this.search.receiptSearch = false
    this.skeletonLoader = false
    this.eventBasedOfferingType = false
    this.isDisable = true
    this.contactComp = false
  }

  async onSelect(key) {
    switch (key) {
      case "event":
        this.search.eventSearch = !this.search.eventSearch
        this.search.contactSearch = false
        this.search.magazineSearch = false
         this.selectEventSkeleton = true
        await this.eventSelectionBoxRefresh()
        this.contactComp = false
        this.search.partnerCodeSearch = false
        this.search.receiptSearch = false
        break;
      case "contact":
        this.search.contactSearch = !this.search.contactSearch
        this.search.eventSearch = false
        this.search.magazineSearch = false
        this.contactEventSkeleton = true
        await this.contactSelectionBoxRefresh()
        this.contactComp = false
        this.search.partnerCodeSearch = false
        this.search.receiptSearch = false
        break;
      case "magazine":
        this.search.magazineSearch = !this.search.magazineSearch
        this.search.eventSearch = false
        this.search.contactSearch = false
        this.contactComp = false
        this.search.partnerCodeSearch = false
        this.search.receiptSearch = false
        break;
      case "partnerCode":
        this.search.partnerCodeSearch = !this.search.partnerCodeSearch
        this.search.magazineSearch = false
        this.search.eventSearch = false
        this.search.contactSearch = false
        this.contactComp = false
        this.search.receiptSearch = false
        break;
      case "receipt":
        this.search.receiptSearch = !this.search.receiptSearch
        this.search.partnerCodeSearch = false
        this.search.magazineSearch = false
        this.search.contactSearch = false
        this.search.eventSearch = false
        this.bankSkeleton = true
        await this.bankSelectionBoxRefresh()
        this.offeringTypeSkeleton = true
        await this.offeringTypeSelectionBoxRefresh()
        this.modeSkeleton = true
        this.modeSelectionBoxRefresh()
        this.contactComp = false
        this.selectReceiptEventSkeleton = true
        this.eventReceiptSelectionBoxRefresh()
        break;
    }
    if (this.search.eventSearch || this.search.magazineSearch || this.search.contactSearch || this.search.partnerCodeSearch || this.search.receiptSearch) {
      this.isDisable = false
    } else {
      this.isDisable = true
    }
  }

  async selectMagazineSearch(key) {
    switch (key) {
      case "tamil":
        this.magazineSearch.tamil = !this.magazineSearch.tamil
        this.magazineSearch.english = false
        this.magazineSearch.hindi = false
        break;
      case "english":
        this.magazineSearch.tamil = false
        this.magazineSearch.english = !this.magazineSearch.english
        this.magazineSearch.hindi = false
        break;
      case "hindi":
        this.magazineSearch.tamil = false
        this.magazineSearch.english = false
        this.magazineSearch.hindi = !this.magazineSearch.hindi
        break;
      default:
        break;
    }
  }

  async outToParent(e) {
    if (e == 'emit') {
      this.skeletonLoader = false
      this.submitLoading = false
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar)) || event.keyCode == 32) {
      event.preventDefault();
    }
    if (event.keyCode == 13) {
      var s = $("#partnerCodeSearch").val();
      $("#partnerCodeSearch").val(s + "\n");
    }
  }

  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      event.preventDefault();
    } 
  }

}
